import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import ColorButton from '../Buttons/ColorButton';
import apptheme from '../theme/default';
import { Box } from '@mui/material'

const SubmenuCard = ({ value, cardName, setSelectedTab, setSelectedSubmenu }) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <ColorButton
                onClick={handleClick}
                sx={{ height: '8rem', flex: 1, visibility: !value.obj ? 'hidden' : 'visible' }}
                fColor={apptheme.primaryColor}
                sColor={apptheme.tertiaryColor}>
                <Box className='flexbox'>
                    {value.icon}
                    {value.title}
                </Box>
            </ColorButton>
            <Menu
                id="fade-menu-card"
                MenuListProps={{
                    'aria-labelledby': 'fade-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
            >
                {Object.entries(value.submenuList).map(([key, item]) => (
                    <MenuItem onClick={() => { setSelectedTab(cardName); setSelectedSubmenu(key) }} key={key} sx={{ padding: '0.5rem 1rem' }}>
                        {item.title}
                    </MenuItem>
                ))}
            </Menu>

        </>
    )
}

export default SubmenuCard;